import { expValEquals } from '@confluence/feature-experiments';

type NativeScheduler = {
	postTask: (callback: () => void, options?: { priority?: 'user-blocking' }) => Promise<unknown>;
};

// Hydration waits for the last preload, so the deferred start runs ahead of normal-priority tasks
// where postTask is available.
function scheduleUserBlockingTask(callback: () => void) {
	const nativeScheduler = (globalThis as { scheduler?: Partial<NativeScheduler> }).scheduler;
	if (typeof nativeScheduler?.postTask === 'function') {
		void nativeScheduler.postTask(callback, { priority: 'user-blocking' });
	} else {
		setTimeout(callback, 0);
	}
}

/**
 * The preload runs while the module that defines the loadable is evaluating, inside a boot long
 * task. Its split files are not loaded yet, so starting it in its own task only moves the
 * synchronous TaskManager and import() setup out of that long task.
 */
export function startPreload(start: () => void): void {
	if (expValEquals('confluence_defer_loadable_preload_start', 'isEnabled', true)) {
		scheduleUserBlockingTask(start);
	} else {
		start();
	}
}
